import { z } from 'zod'
import { CompanyAddressType, type CompanyAddress } from '../../models/CompanyAddress'
import { AddressDTO, mapAddressToDTO, mapDTOToAddress } from '~/domain/shared/address/gateways/DTOs/AddressDTO'

export const CompanyAddressDTO = AddressDTO.extend({
  type: z.nativeEnum(CompanyAddressType)
})

export type CompanyAddressDTO = z.infer<typeof CompanyAddressDTO>

export function mapCompanyAddressToDTO (model: CompanyAddress): CompanyAddressDTO {
  return {
    ...mapAddressToDTO(model.address),
    type: model.type
  }
}

export function mapDTOToCompanyAddress (dto: CompanyAddressDTO): CompanyAddress {
  return {
    address: mapDTOToAddress(dto),
    type: dto.type
  }
}
